/**
    * Receiving Report
    * Receiving Report panel will have all the data which is  updated on receiving panel
    * Author: Aparna
    * 
    * */
/**
 * RR_PC_01
 * importing action,store and SDIconstants,translation, jquery,component router
 * */
import React, { Component } from 'react';
import * as $ from 'jquery';
import * as MenuAction from '../actions/MenuAction';
import * as RcvRptAction from '../actions/RcvRptAction';
import RcvRptStore from '../stores/RcvRptStore';
import SDIConstants from '../SDIConstants';
import * as CookieService from '../CookieService';
import { withTranslation, Trans } from 'react-i18next'
import ReactPaginate from 'react-paginate';
import DatePicker from "react-datepicker";
//[2/23/22], WBW - 11, PC_RR_04, Dhevanesam R
import * as OrderStatusAction from '../actions/OrderStatusAction';
import OrderStatusStore from '../stores/OrderStatusStore';
import swal from 'sweetalert';
let currentPagePath;
let IsPageLoad = true;
let descendingOrder = true;
let ascendingOrder = true;
/**
 * RR_PC_0
 * */

class RcvRptComponent extends Component {
    constructor(props) {
        super(props);
        this.SearchCriteriaCheck = this.SearchCriteriaCheck.bind(this);
        this.bindTracking_no = this.bindTracking_no.bind(this);
        /**
    * RR_PC_03
    * intilize the variable used in this component
    * */

        this.state = {
            GridData: [],
            PageNo: "1",
            SelectedReport: "X",
            FromDate: "",
            ToDate: "",
            SearchBy: "PO Number",
            SearchCriteria: "",
            ExportToExcel: [],
            ShipToDD: [],
            UseDateRangeCheckbox: false,
            POID: "",
            isFavorited: false,
            PageCount: 0,
            //[2/23/22], WBW - 11, PC_RR_04, Dhevanesam R
            VenderDetail: [],
            POData: [],
            DetailTable: [],
            VenderDetail: [],
            packingSlip: [],
            //[12/2/22, Bug - 2958 - To display expand and collapse all button text & functionality in a single button, Dhevanesam R]
            isPOExpand: false, POTracking_no: []
        }
    }
    componentWillUnmount() {
        RcvRptStore.removeListener('PageLoad', this.RRPageLoadResponse.bind(this));
        RcvRptStore.removeListener('Go', this.GoButtonClickResposne.bind(this));
        RcvRptStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        RcvRptStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));
        //WBW - 11 Receiving Report - Excel Change - Deepthi N H
        RcvRptStore.removeListener('Export', this.FileExport);
        //[2/23/22], WBW - 11, PC_RR_04, Dhevanesam R
        OrderStatusStore.removeListener('POdetail', this.PODetail);

    }
    /**
     * RR_PC_04
     * */
    componentDidMount() {
        //WW-635_PC_01 (2/20/2023)-Aparna
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        IsPageLoad = true;
        let cribID = "";
        if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != null && CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != undefined && CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != " ") {
            cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        }
        if (cribID.trim() == "") {

            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        RcvRptAction.getCurrentFavPage(getFavPageBO);

        let BO = {
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
            Session_SmallSite: CookieService.getLocalStorageValues("Session_SmallSite"),
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        // RcvRptAction.RRPageLoadAction(BO);

        RcvRptStore.on('RRPageLoad', this.RRPageLoadResponse);
        RcvRptStore.on('Go', this.GoButtonClickResposne);
        RcvRptStore.on('favpage', this.loadFavPageResponse.bind(this));
        RcvRptStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
        RcvRptStore.on('Export', this.FileExport);
        //[2/23/22], WBW - 11, PC_RR_04, Dhevanesam R
        OrderStatusStore.on('POdetail', this.PODetail);
    }
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(RcvRptStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        if (RcvRptStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(RcvRptStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(RcvRptStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        //this.refreshMenu();
    };
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Receiving Report",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            RcvRptAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            RcvRptAction.deleteFavPage(deleteFavPageBO)
        }
    };

    /**
     * RR_PC_05
     * */
    RRPageLoadResponse = () => {
        //4759 - Restrict Order Date option in duplicate tab
        this.setState({ SelectedReport: "X" });
    }

    /**
     * RR_PC_07
     * */
    SearchCriteriaCheck = () => {
        
        if (this.state.SelectedReport == "X") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Select report date"
            });
            //alert("Select report date")
            return;
        }
        else if (this.state.SelectedReport != "99") {
            this.GoButtonClick()
        }
        else {
            if (this.state.SearchCriteria != "") {
                if (this.state.UseDateRangeCheckbox == true) {
                    if (this.state.FromDate == "" || this.state.ToDate == "" || this.state.FromDate == null || this.state.ToDate == null) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Enter valid date"
                        });
                        //alert("Enter valid date")
                        return
                    }
                    else {
                        let months;
                        months = (new Date(this.state.ToDate).getDate() - new Date(this.state.FromDate).getDate()) / 30 +
                            new Date(this.state.ToDate).getMonth() - new Date(this.state.FromDate).getMonth() +
                            (12 * (new Date(this.state.ToDate).getFullYear() - new Date(this.state.FromDate).getFullYear()));

                        if (months <= 6) {
                            this.GoButtonClick()
                        }
                        else {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Enter date range within 6 months"
                            });
                            // alert("Enter date range within 6 months")
                            return
                        }

                    }
                }
                else {
                    this.GoButtonClick()

                }
            }
            else if (this.state.SearchCriteria == "" && this.state.FromDate == null && this.state.ToDate == null) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Enter any criteria"
                });
                // alert("Enter any criteria")
                return
            }
            else if (this.state.FromDate == "" || this.state.ToDate == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Enter valid date"
                });
                // alert("Enter valid date")
                return
            }
            else if (this.state.FromDate != "" || this.state.ToDate != "") {
                let months;
                months = (new Date(this.state.ToDate).getDate() - new Date(this.state.FromDate).getDate()) / 30 +
                    new Date(this.state.ToDate).getMonth() - new Date(this.state.FromDate).getMonth() +
                    (12 * (new Date(this.state.ToDate).getFullYear() - new Date(this.state.FromDate).getFullYear()));

                if (months <= 3) {
                    this.GoButtonClick()
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Enter date range within 3 months"
                    });
                    //  alert("Enter date range within 3 months")
                    return
                }
            }

        }
    }
    /**
     * RR_PC_11
     * to change the date formate to pass it ot back end
     * */
    handledate = (date) => {
        if (date != null) {
            return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
        }
    }
    /**
     * RR_PC_08
     * */
    GoButtonClick = () => {
        IsPageLoad = false;
        let From = this.state.FromDate
        let To = this.state.ToDate
        if (this.state.SelectedReport == "99") {
            if (this.state.FromDate != "" && this.state.ToDate != "") {
                From = this.handledate(this.state.FromDate);
                To = this.handledate(this.state.ToDate);
            }
        }
        //WW-635_PC_03 (2/20/2023) -Aparna
        let cribID = "";
        if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != null && CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != undefined) {
            cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        }
        let BO = {
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
            Session_SmallSite: CookieService.getLocalStorageValues("Session_SmallSite"),
            txtSearchCriteria: this.state.SearchCriteria.trim(),
            dropSearchBy: this.state.SearchBy,
            Report: this.state.SelectedReport,
            FromDate: From,
            ToDate: To,
            usedate: this.state.UseDateRangeCheckbox,
            crib: cribID         //WW-635_PC_03 (2/20/2023) -Aparna
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        RcvRptAction.GoButtonClickAction(BO);

    }
    /**
     * RR_PC_
     * */
    GoButtonClickResposne = () => {
        
        let Response = JSON.parse(RcvRptStore.PageLoadData);
        if (Response.GridData != "") {
            let tot = Response.GridData.length
            let count = parseFloat(Response.GridData.length) / 10
            this.setState({ GridData: Response.GridData, totalCount: tot, PageCount: count, PageNo: "1" });
        }
        else {
            this.setState({ GridData: [], totalCount: 0, PageCount: 0 });
        }
    }
    onAccordianClick = (event, index) => {
        const $currentOpenAccordion = $(`#contentrow-${index}`);
        const isCurrentlyOpen = $currentOpenAccordion.hasClass('d-none') === false;

        // Close all open accordions
        $('.content-row').addClass('d-none');
        $('.accordion-arrow').removeClass('accordion-arrow-change');

        if (!isCurrentlyOpen) {
            // Open the clicked accordion
            $currentOpenAccordion.removeClass('d-none');
            $(`#arrow-${index}`).addClass('accordion-arrow-change');
        }

        $('tr').removeClass('tr-border');
        if (isCurrentlyOpen === false) {
            $(event.currentTarget).parent('tr').addClass('tr-border');
        }
    };
    /**
     * RR_PC_06
     * */
    OnHandleChange = (e, name, select) => {

        switch (name) {
            case "SearchBy": {
                IsPageLoad = true;
                e.preventDefault();
                this.setState({ SearchBy: select });
                break;
            }
            case "SelectedReport":
                //WW-863 INC0029757 Previous Days Report in Walmart 2.0, when I export into excel (attached) it shows a full 30 days on the excel sheet, and not even current - Deepthi N H
                if (e.target.value != "99") {
                    IsPageLoad = true;
                    this.setState({ FromDate: "", ToDate: "", SearchCriteria: "" });
                }
            case "SearchCriteria":
                {
                    e.preventDefault();
                    IsPageLoad = true;
                    this.setState({ [name]: e.target.value, GridData: [], totalCount: 0 });
                    break;
                }
            case "FromDate": case "ToDate": {
                IsPageLoad = true;
                // let dateOL = this.handledate(date);
                this.setState({ [name]: e });
                break;
            }
            case "UseDateRangeCheckbox": {
                IsPageLoad = true;
                //e.preventDefault();
                this.setState({ UseDateRangeCheckbox: this.state.UseDateRangeCheckbox == false ? true : false });
                break;
            }
        }
    }
    ClearSearch = () => {
        this.setState({ SearchCriteria: "" })
    }
    /**
     * RR_PC_09
     * */
    StoreLocationClick = (id) => {

        $('#StoreLocation-id').modal('show');
        this.setState({ POID: id })

    }
    /*
     * RR_PC_10
     * */
    BindStoreLocation = (id) => {
        if (this.state.StoreLocation != null || this.state.StoreLocation != undefined) {
            return this.state.StoreLocation.filter((x) => x.INV_ITEM_ID == this.state.POID).map((value, ID) => {
                return (
                    <tr>
                        <td>{}</td>
                        <td>{value.STORAGE_AREA}</td>
                        <td>{value.STOR_LEVEL_1}</td>
                        <td>{value.STOR_LEVEL_2}</td>
                        <td>{value.STOR_LEVEL_3}</td>
                        <td>{value.STOR_LEVEL_4}</td>
                        <td>`${value.QTY} ${value.UNIT_OF_MEASURE}`</td>
                    </tr>
                )

            });
        }
    }
    handlePageClick = (e) => {
        let pageNo = e.selected + 1;
        this.setState({ PageNo: pageNo });
    }
    /**
     * 
     * */
    export = () => {
        
        //WBW - 11 Receiving Report - Excel Change - Deepthi N H
        let From = this.state.FromDate
        let To = this.state.ToDate
        if (this.state.SelectedReport == "99") {
            if (this.state.FromDate != "" && this.state.ToDate != "") {
                From = this.handledate(this.state.FromDate);
                To = this.handledate(this.state.ToDate);
            }
        }
        //WW-635_PC_03 (2/20/2023) -Aparna
        let cribID = "";
        if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != null && CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != undefined) {
            cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        }
        let BO = {
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
            Session_SmallSite: CookieService.getLocalStorageValues("Session_SmallSite"),
            txtSearchCriteria: this.state.SearchCriteria.trim(),
            dropSearchBy: this.state.SearchBy,
            Report: this.state.SelectedReport,
            FromDate: From,
            ToDate: To,
            usedate: this.state.UseDateRangeCheckbox,
            crib: cribID         //WW-635_PC_03 (2/20/2023) -Aparna
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        RcvRptAction.ExportData(BO);
        //----------------------------------------Commented as we do export to excel from API - Deepthi N H -------------------------------------------------------------------
        //dt = this.state.GridData
        //const EX = ['Business Unit', 'Buyer ID', 'Recv. ID', 'Recv. Ln#', 'Receipt DT', 'Ship To', 'PO DT', 'PO #', 'PO Bus. Unit', 'Ln', 'SDI ItemID',
        //    'Bin Location', 'Short Descr', 'Net Received QTY', 'Accepted Qty', 'Received Qty', 'Rejected Qty', 'Returned Qty',
        //    'PO Price', 'Ext. Price', 'Stock Type', 'Work Order#', 'Machine#', 'BU In',
        //    'UOM', 'Ship via', 'OPRID', 'OPRNAME', 'Tariff Code', 'Item Weight', 'Descr. Translation', 'Emp. ID',  'Cust Notes', 'Req. Currency', 'PO Currency'
        //    , 'Tracking #', 'Mfg ID', 'Mfg Item ID', 'Chg. Cd', 'Item Master Chg. Cd.', 'Vnd Item ID', 'Vendor ID', 'Vendor', 'Description', 'PO Qty'
        //    , 'Ship Date', 'Serial Id', 'Dept Id', 'Price Curncy', 'EXT PO QTY']
        //let locArr = [];
        //this.state.GridData.map((X) => {

        //    let loc = {
        //        VendorName: X.NAME1,
        //        BUYER_ID: X.BUYER_ID,
        //        RECEIVER_ID: X.RECEIVER_ID,
        //        RECV_LN_NBR: X.RECV_LN_NBR,
        //        RECEIPT_DI: X.RECEIPT_DI,
        //        SHIPTO_ID: X.SHIPTO_ID,
        //        PO_DATE: X.PO_DATE,
        //        PO_ID: X.PO_ID,
        //        INV_ITEM_ID: X.INV_ITEM_ID,
        //        BIN_LOC: X.BIN_LOC,
        //        SHORT_DESCR: X.SHORT_DESCR,
        //        QTY_SH_NETRCV: X.QTY_SH_NETRCV,
        //        QTY_LN_ACCPT:X. QTY_LN_ACCPT,
        //        QTY_LN_RECVD: X.QTY_LN_RECVD,
        //        QTY_LN_REJCT: X.QTY_LN_REJCT,
        //        QTY_LN_RTN: X.QTY_LN_RTN,
        //        PRICE_PO: X.PRICE_PO,
        //        EXT_PRICE: X.EXT_PRICE,
        //        INV_STOCK_TYPE: X.INV_STOCK_TYPE,
        //        ISA_WORK_ORDER_NO: X.ISA_WORK_ORDER_NO,
        //        ISA_MACHINE_NO: X.ISA_MACHINE_NO,
        //        BUSINESS_UNIT_IN: X.BUSINESS_UNIT_IN,
        //        UNIT_MEASURE_STD: X.UNIT_MEASURE_STD,
        //        ISA_ASN_SHIP_VIA: X.ISA_ASN_SHIP_VIA,
        //        OPRID: X.OPRID,
        //        OPRNAME: X.OPRNAME,
        //        ISA_TARIFF_CODE: X.ISA_TARIFF_CODE,
        //        INV_ITEM_WEIGHT: X.INV_ITEM_WEIGHT,
        //        ISA_ITEM_TRANSLATE: X.ISA_ITEM_TRANSLATE,
        //        ISA_EMPLOYEE_ID: X.ISA_EMPLOYEE_ID,
        //        ISA_RECV_EXCEPT: X.ISA_RECV_EXCEPT,
        //        CURRENCY_CD: X.CURRENCY_CD,
        //        PO_CURRENCY: X.PO_CURRENCY,
        //        ISA_ASN_TRACK_NO: X.ISA_ASN_TRACK_NO,
        //        MFG_ID: X.MFG_ID,
        //        MFG_ITM_ID: X.MFG_ITM_ID,
        //        ISA_CUST_CHARGE_CD: X.ISA_CUST_CHARGE_CD,
        //        MASTER_CHARGE_CD: X.MASTER_CHARGE_CD,
        //        ITM_ID_VNDR: X.ITM_ID_VNDR,
        //        VENDOR_ID: X.VENDOR_ID,
        //        NAME1: X.NAME1,
        //        DESCR254_MIXED: X.DESCR254_MIXED,
        //        QTY_PO: X.QTY_PO,
        //        ISA_ASN_SHIP_DT: X.ISA_ASN_SHIP_DT,
        //        SERIAL_ID: X.SERIAL_ID,
        //        DEPTID: X.DEPTID,
        //        PRICE_PO: X.PRICE_PO,
        //        EXT_PO_QTY: X.EXT_PO_QTY,
        //    }
        //    locArr.push(loc)
        //})
        //// let myArr = [...this.state.GridData]
        //this.setState({ isexport: true, Arr: locArr });
        ////[12/30/21, PC_SC_04], Priyanka D//Invoke "convertArrayToTable" for exporting Excel in .xls form*/
        //this.convertArrayToTable(locArr, "Receiving Report");
        ////this.exporttoexcel(locArr);
    }
    //WBW - 11 Receiving Report - Excel Change - Deepthi N H
    FileExport = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let expfile = JSON.parse(RcvRptStore.Excel);

    }
    convertArrayToTable = (locArr, Exporttoexcel) => {
        //use keys from the first array object to form table column headers
        const tableHeaders = `<tr>${Object.keys(locArr[0]).map(key => `<td>${key}</td>`).join('')}</tr>`;
        //now loop through all array objects to form table rows
        const tableRows = locArr.map(obj =>
            [`<tr>
         ${Object.keys(obj).map(key => `<td>${obj[key] === null || obj[key] === '' ? '' : obj[key]}</td>`).join('')}
      <tr/>`]).join('');
        const table = `<table>${tableHeaders}${tableRows}</table>`.trim();


        const xmlTable = this.createXMLTable(table, "Receiving Report");//WW-326_PC_03 changing table name (18/2/2022)-Aparna
        const downloadURL = this.createFileUrl(xmlTable);
        this.downloadFile(downloadURL, "Receiving Report");
    }
    createXMLTable = (table, fileName) => {
        const xmlTable = `
        <html xmlns:o="urn:schemas-microsoft-com:office:office xmlns:x="urn:schemas-microsoft-com:office:excel"
       xmlns="http://www.w3.org/TR/REC-html40"
        >
           <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"/>
           <head>
              <xml>
                <x:ExcelWorkbook>
                    <x:ExcelWorksheets>
                        <x:ExcelWorksheet>
                            <x:Name>${fileName}</x:Name>
                            <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                        </x:ExcelWorksheet>
                    </x:ExcelWorksheets>
                </x:ExcelWorkbook>
              </xml>
           </head>
           <body>
             ${table}
           </body>
        </html> `
        return xmlTable;
    }
    createFileUrl = (xmlTable) => {
        const tableBlob = new Blob([xmlTable], { type: 'application/vnd.ms-excel;base64,' });
        const downloadURL = URL.createObjectURL(tableBlob);
        return downloadURL;
    }
    downloadFile = (downloadURL, fileName) => {
        const downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);
        downloadLink.download = fileName;
        downloadLink.href = downloadURL;
        downloadLink.click();
    }
    //[2/23/22], WBW - 11, PC_RR_04, Dhevanesam R
    POData = () => {
        //return this.state.POData.map((value, index) => {
        if (this.state.POData.length > 0) {


            return (
                <div className="col-md-12 col-lg-4 float-left">
                    <div className="row">
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label">SDI PO:</label>
                            <label className="info-value pl-1">{this.state.POData[0].PO_ID}</label>
                        </div>
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label"><Trans>order_key</Trans><span> No</span><span>:</span></label>
                            <label className="info-value pl-1">{this.state.POData[0].ORDER_NO}</label>
                        </div>
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label"><Trans>workorder_key</Trans><span> </span><Trans>Number</Trans><span>:</span></label>
                            <label className="info-value pl-1" >{this.state.POData[0].ISA_WORK_ORDER_NO}</label>
                        </div>
                    </div>
                </div>
            );
        }
        //})
    }
    PoHdStatus = () => {

        if (this.state.POData.length > 0) {
            console.log("status", this.state.POData[0].PO_STATUS);
            let Hdstatus = "Initial";
            let val = this.state.POData[0].PO_STATUS;
            switch (val) {
                case 'A':
                    Hdstatus = "Approved"
                    break;
                case 'C':
                    Hdstatus = "Complete"
                    break;
                case 'D':
                    Hdstatus = "Dispatched"
                    break;
                case 'DA':
                    Hdstatus = "Denied"
                    break;
                case 'I':
                    Hdstatus = "Initial"
                    break;
                case 'LD':
                    Hdstatus = "Line Denied"
                    break;
                case 'O':
                    Hdstatus = "Open"
                    break;
                case 'PA':
                    Hdstatus = "Pend Appr"
                    break;
                case 'PX':
                    Hdstatus = "Pend Cncl"
                    break;
                case 'X':
                    Hdstatus = "Canceled"
                    break;


            }
            return (
                <label className="info-value pl-1">{Hdstatus}</label>

            );
        }
    }
    //WW-819_PC_04 -Aparna
    bindTracking_no = (val) => {
        return this.state.POTracking_no.map((value) => {
            if (val.LINE_NBR == value.LINE_NBR)
                return (
                    <>
                        <div className="col-md-3 pr-0 pl-2 responsive-iphone-grid">
                            <label className="catalog-label float-none  mr-2"><Trans>Tracking no</Trans><span>:</span></label>
                            <label className="item-details-value float-none"> <a href={value.ISA_NEW_URL} target="_blank" >{value.ISA_ASN_TRACK_NO} </a>
                            </label></div>
                        <div className="col-md-8 pr-0 pl-2 responsive-iphone-grid">
                            <label className="catalog-label float-none  mr-2"><Trans>Ship Date</Trans><span>:</span></label>
                            <label className="item-details-value float-none">{value.ISA_ASN_SHIP_DT}
                            </label></div>
                    </>
                )
        })
    }
    bindPODataGrid = () => {
        ////;
        if (this.state.POData.length > 0) {

            let TrackNum
            return this.state.POData.map((value, index) => {
                /*BUG:2473-Replace "||" in Tracking Number-Priyanka D*/
                let ISA_ASN_TRACK_NO = value.ISA_ASN_TRACK_NO.split("||")
                let TrackNum
                if (ISA_ASN_TRACK_NO != undefined) {
                    TrackNum = ISA_ASN_TRACK_NO[0].replace("||", "")
                }
                return (
                    <>
                        <tr>
                            {/* <td data-toggle="collapse" data-target="#order-row-1-popup" className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)}>*/}
                            <td className="accordion-toggle" onClick={(e) => this.onAccordianPOClick(e, index)} >
                                <span className="accordion-arrow header-arrow tryH" id={`arrowPOHeader-${index}`} />
                            </td>
                            <td>{value.REQ_LINE_NBR}</td>
                            <td>{value.LINE_NBR}</td>
                            <td className="d-none d-sm-none d-md-table-cell">{value.SCHED_NBR}</td>
                            {this.PoStatus(value)}
                            <td className="d-none d-sm-none d-md-table-cell">{value.ORIG_DUE_DT}</td>
                            <td className="d-none d-sm-none d-md-table-cell">{value.DUE_DT}</td>
                            <td className="d-none d-sm-none d-md-table-cell">{value.req_by_date}</td>
                            <td className="d-none d-sm-none d-md-table-cell">{value.QTY_PO}</td>
                            <td className="d-none d-sm-none d-md-table-cell">{value.QTY_LN_RECVD == " " ? "0.00" : value.QTY_LN_RECVD}</td>
                            <td className="d-none d-sm-none d-md-table-cell">{value.QTY_LN_REJCT == " " ? "0.00" : value.QTY_LN_REJCT}</td>
                            {this.state.showprice != "0" && this.state.blockprice == "N" ? <td className="text-right">{value.purchase_price}</td> : null}
                        </tr>
                        <tr className="p d-none content-row try" id={`contentPOrow-${index}`}>
                            <td colSpan={12} className="hiddenRow">
                                <div className="py-1">
                                    <div className="row mx-0">
                                        <div className="col-md-12 pl-5">
                                            <div className="row">
                                                <div className="col-md-12 mb-1">
                                                    <div className="row mx-0">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="col-md-12 mb-1">
                                                                    <div className="row">
                                                                        {/* <div className="col-12 mobile-fieldscontainer p-0">*/}
                                                                        <div className="col-lg-3 col-md-12 col-sm-12 pr-0  responsive-iphone-grid">
                                                                            <label className="catalog-label  mr-2">Sch #<span> :</span></label>
                                                                            <label className="item-details-value">{value.SCHED_NBR}</label>
                                                                        </div>
                                                                        <div className="col-lg-3 col-md-12 col-sm-12 pr-0  responsive-iphone-grid">
                                                                            <label className="catalog-label mr-2"><span>Orig. Due </span><Trans>Date</Trans><span> :</span></label>
                                                                            <label className="item-details-value">{value.ORIG_DUE_DT}</label>
                                                                        </div>
                                                                        <div className="col-lg-3 col-md-12 col-sm-12 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label mr-2"><Trans>Delivery</Trans><span> </span><Trans>Date</Trans><span> :</span></label>
                                                                            <label className="item-details-value">{value.DUE_DT}</label>
                                                                        </div>
                                                                        <div className="col-lg-3 col-md-12 col-sm-12 pr-0  responsive-iphone-grid">
                                                                            <label className="catalog-label mr-2"><Trans>Request by</Trans><span> </span><Trans>Date</Trans><span> :</span></label>
                                                                            <label className="item-details-value ">{value.req_by_date}</label>
                                                                        </div>
                                                                        <div className="col-lg-3 col-md-12 col-sm-12 pr-0  responsive-iphone-grid">
                                                                            <label className="catalog-label mr-2">PO QTY : </label>
                                                                            <label className="item-details-value">{value.QTY_PO}</label>
                                                                        </div>
                                                                        <div className="col-lg-3 col-md-12 col-sm-12 pr-0  responsive-iphone-grid">
                                                                            <label className="catalog-label mr-2"><Trans>Received</Trans><span> QTY</span><span> :</span></label>
                                                                            <label className="item-details-value">{value.QTY_LN_RECVD == " " ? "0.00" : value.QTY_LN_RECVD}</label>
                                                                        </div>
                                                                        <div className="col-lg-3 col-md-12 col-sm-12 pr-0  responsive-iphone-grid">
                                                                            <label className="catalog-label mr-2"><Trans>Reject</Trans><span> QTY</span><span> :</span></label>
                                                                            <label className="item-details-value">{value.QTY_LN_REJCT == " " ? "0.00" : value.QTY_LN_REJCT}</label>
                                                                        </div>
                                                                        {/*</div>*/}
                                                                        {this.state.showprice != "0" && this.state.blockprice == "N" ?
                                                                            <div className="col-lg-3 col-md-6 col-sm-12 pr-0 responsive-iphone-grid">
                                                                                <label className="catalog-label float-none mr-2"><span>Ext. </span><Trans>Price</Trans><span> :</span></label>
                                                                                <label className="item-details-value float-none pl-1">{value.ext_price}</label>
                                                                            </div> : null}
                                                                        <div className="col-lg-3 col-md-6 col-sm-12 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none mr-2"><Trans>Item ID</Trans><span> :</span></label>
                                                                            <label className="item-details-value float-none pl-1">{value.INV_ITEM_ID == " " ? "Non-Stock" : value.INV_ITEM_ID}</label>
                                                                        </div>
                                                                        <div className="col-lg-3 col-md-6 col-sm-12 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none mr-2">MFG <span> : </span></label>
                                                                            <label className="item-details-value float-none pl-1">{value.MFG_ID && value.MFG_ID.trim() ? value.MFG_ID.trim() : "-"}</label>
                                                                        </div>
                                                                        <div className="col-lg-3 col-md-6 col-sm-12 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none mr-2"><span>MFG </span><Trans>Part</Trans><span> Num</span><span> :</span></label>
                                                                            <label className="item-details-value float-none pl-1">{value.MFG_ITM_ID && value.MFG_ITM_ID.trim() ? value.MFG_ITM_ID.trim() : "-"}</label>
                                                                        </div>
                                                                        {/*<div className="col-md-3 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none"><Trans>Tracking</Trans><span> Num:</span></label>
                                                                            {/*BUG:2473-Replace "||" in Tracking Number-Priyanka D*/}
                                                                        {/*{ISA_ASN_TRACK_NO[1] != null && ISA_ASN_TRACK_NO[1] != undefined && ISA_ASN_TRACK_NO[1] != "" && ISA_ASN_TRACK_NO[1] != " " ?
                                                                                <a href={ISA_ASN_TRACK_NO[1]} target="_blank" >{TrackNum} </a> :
                                                                                <label className="catalog-label float-none">{TrackNum} </label>
                                                                            }
                                                                        </div>*/}
                                                                        <div className="col-lg-3 col-md-6 col-sm-12 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none mr-2"><Trans>Ship Via</Trans><span> :</span></label>
                                                                            <label className="item-details-value float-none">{value.ISA_ASN_SHIP_VIA && value.ISA_ASN_SHIP_VIA.trim() ? value.ISA_ASN_SHIP_VIA.trim() : "-"}
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-lg-3 col-md-6 col-sm-12 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none mr-2"><Trans>Invoice</Trans><span> :</span></label>
                                                                            <label className="item-details-value float-none">{value.invoice_id && value.invoice_id.trim() ? value.invoice_id.trim() : "-"}
                                                                            </label></div>
                                                                        <div className="col-lg-3 col-md-6 col-sm-12 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none mr-2"><Trans>Invoice</Trans><span> Amt</span><span> :</span></label>
                                                                            <label className="item-details-value float-none" >{value.invoice_amt && value.invoice_amt.trim() ? value.invoice_amt.trim() : "-"}</label>
                                                                        </div>
                                                                        <div className="col-lg-3 col-md-6 col-sm-12 pr-0 responsive-iphone-grid "><label className="catalog-label float-none  mr-2"><Trans>Invoice</Trans><span> </span><Trans>Date</Trans><span> :</span></label>
                                                                            <label href="#" className="item-details-value float-none ">{value.invoice_date && value.invoice_date.trim() ? value.invoice_date.trim() : "-" }</label></div>
                                                                        <div className="col-lg-3 col-md-6 col-sm-12 pr-0 responsive-iphone-grid "><label className="catalog-label float-none  mr-2"><Trans>Packing Slips</Trans><span> :</span></label>
                                                                            {this.packingSlip(value) == "" ? "-" : this.packingSlip(value)}
                                                                        </div>
                                                                        <div className="col-lg-3 col-md-6 col-sm-12 pr-0 responsive-iphone-grid">
                                                                            <label className="catalog-label float-none mr-2"><span>Emp.</span><Trans>Name</Trans><span> :</span></label>
                                                                            <label className="item-details-value float-none">{value.OPRID_ENTERED_BY && value.OPRID_ENTERED_BY.trim() ? value.OPRID_ENTERED_BY : "-"}</label>
                                                                        </div>
                                                                        {/*WW-819_PC_01 */}
                                                                        <div className="col-md-12 pr-0  responsive-iphone-grid">
                                                                            <div className="row">

                                                                                {this.bindTracking_no(value)}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12 mb-1 ">
                                                                    <div className="row">
                                                                        <div className="col-md-12 pr-0">
                                                                            <label class="catalog-label float-none mr-2"><span><Trans>Description</Trans> :</span></label>
                                                                            <label className="item-details-value float-none">{value.DESCR254_MIXED == " " ? "-" : value.DESCR254_MIXED}</label>
                                                                        </div>
                                                                    </div></div>
                                                            </div>
                                                        </div></div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </>
                )
            });
        }
        if (this.state.POData.length == 0) {
            return (
                <span className="noitemdisplay" id="StatusMsg"><Trans>No records to display</Trans></span>
            );
        }
    }
    packingSlip = (OrderDetail) => {
        let packingSlip = this.state.packingSlip.filter((item, index) => item.INV_ITEM_ID == OrderDetail.INV_ITEM_ID);
        return packingSlip.map((Item, index) => {
            //;
            if (Item.Packslip == true) {
                return (
                    <label className="item-details-value"><a href="#"><img src="Images/history.png" /></a></label>
                );
            }
        })
    }
    PODetailhd = () => {
        //;
        if (this.state.VenderDetail.length > 0) {

            let VenderDetail = this.state.VenderDetail;
            console.log("address", this.state.VenderDetail);
            let separatedArray = [];
            let Phone = [];
            Phone = this.state.VenderDetail[0].lblPOVendorPhoneData.split('<br />');
            separatedArray = this.state.VenderDetail[0].sAddress.split('<br />');
            console.log("splice arr", separatedArray);
            //for (let value in VenderDetail) {
            //    let addr = VenderDetail[value].sAddress;

            return (<div>

                <div className="col-md-12 col-lg-3 float-left">
                    <div className="row">
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label mr-2"><Trans>Vendor</Trans><span> </span><Trans>ID</Trans><span>:</span></label>
                            <label className="info-value pl-0">{this.state.VenderDetail[0].sVendorID}</label>
                        </div>
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label mr-2"><Trans>Vendor</Trans><span> LOC :</span></label>
                            <label className="info-value pl-0">{this.state.VenderDetail[0].sVndrLoc}</label>
                        </div>
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label mr-2">Addr Seq<span> :</span></label>
                            <label className="info-value pl-0" >{this.state.VenderDetail[0].lblPOVendorAddrSeqData}</label>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-3 float-left">
                    <div className="row">

                        <div className="col-md-12 float-left p-0">
                            <label className="info-label mr-2"><Trans>Vendor</Trans><span>:</span></label>
                            <label className="info-value pl-0">{this.state.VenderDetail[0].lblPOVendorNameData}</label>


                        </div>
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label mr-2"><Trans>Vendor</Trans><span> </span><Trans>Address</Trans><span>:</span></label>
                            <label className="info-value pl-0" >{separatedArray}</label>
                        </div>

                    </div>
                </div>

                <div className="col-md-12 col-lg-3 float-left">
                    <div className="row">

                        <div className="col-md-12 float-left p-0">
                            <label className="info-label mr-2"><Trans>Contact</Trans><span>:</span></label>
                            {/*WAL-724_PC_02 changing contanct no to 855-446-9423 -Aparna**/}
                            {/*<label className="info-value pl-0">{Phone}</label>*/}
                            <label className="info-value pl-0">855-446-9423</label>


                        </div>
                        <div className="col-md-12 float-left p-0">
                            <label className="info-label mr-2"><Trans>Name</Trans><span>:</span></label>
                            <label className="info-value pl-0" >{this.state.VenderDetail[0].lblPOVendorContactData}</label>
                        </div>

                    </div>
                </div>

            </div>
            );
            //}
        }
    }
    PODetailPopup = (value) => {
        
        let PODetailBO = {
            sPOID: value.PO_ID,
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP")
        }
        //;
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        OrderStatusAction.PODetail(PODetailBO);

    }
    PODetail = () => {
        // Parse the response from the store
        let PageLoadResponse = JSON.parse(OrderStatusStore.PODetailData);
        let PODetails = PageLoadResponse.POData.map((value) => {
            return { ...value, IsExpand: true };
        });

        // Close all accordions
        $('.content-row').addClass('d-none');
        $('.accordion-arrow').removeClass('accordion-arrow-change');

        //[12/2/22, Bug - 2958 - To display expand and collapse all button text & functionality in a single button, Dhevanesam R]
        this.setState({
            DetailTable: PageLoadResponse.DetailTable,
            VenderDetail: PageLoadResponse.VenderDetail,
            POData: PODetails,
            packingSlip: PageLoadResponse.packingSlip,
            isPOExpand: false,
            POTracking_no: PageLoadResponse.tracking_no //WW-819_PC_03 -Aparna
        });

        $('#po-details').modal('show');
    };
    PoStatus = (val) => {


        ////;
        if (this.state.POData.length > 0) {
            let status = "Active";
            let value = val.CANCEL_STATUS;
            console.log("cancel status", value);
            // //;
            switch (value) {
                case "A":
                    status = "Active"
                    break;
                //return <td>Active</td>
                case 'C':
                    status = "Closed"
                    break;
                //return <td>Closed</td>
                case 'D':
                    status = "Denied"
                    break;
                case 'H':
                    status = "Hold"
                    break;
                case 'O':
                    status = "Open"
                    break;
                case 'P':
                    status = "Pending"
                    break;
                case 'X':
                    status = "Canceled"
                    break;

            }
            return (
                <td>{status}</td>
            );
        }
    }
    onAccordianPOClick = (event, index) => {
        const $currentOpenAccordion = $(`#contentPOrow-${index}`);
        const isCurrentlyOpen = $currentOpenAccordion.hasClass('d-none') === false;

        // Close all open accordions
        $('.content-row').addClass('d-none');
        $('.accordion-arrow').removeClass('accordion-arrow-change');

        if (!isCurrentlyOpen) {
            // Open the clicked accordion
            $currentOpenAccordion.removeClass('d-none');
            $(`#arrowPOHeader-${index}`).addClass('accordion-arrow-change');
        }

        $('tr').removeClass('tr-border');
        if (isCurrentlyOpen === false) {
            $(event.currentTarget).parent('tr').addClass('tr-border');
        }
    };
    ////[12/2/22, Bug - 2958 - To display expand and collapse all button text & functionality in a single button, Dhevanesam R]
    POExpandAll = () => {
        if (this.state.isPOExpand) {
            // Collapse all accordions
            this.setState({ isPOExpand: false });
            $('.tryH').removeClass('accordion-arrow-change');
            $('.try').addClass('d-none');
        } else {
            // Expand all accordions
            this.setState({ isPOExpand: true });
            $('.tryH').addClass('accordion-arrow-change');
            $('.try').removeClass('d-none');
        }
    };
    //POCollapseAll = () => {
    //    this.setState({ isPOExpand: false });
    //    $('.tryH').addClass('accordion-arrow-change');
    //    $('.try').removeClass('d-none');
    //    $('.tryH').removeClass('accordion-arrow-change');
    //    $('.try').addClass('d-none');
    //}
    DynamicSort = (sort, name) => {
        
        let GridArray = this.state.GridData;
        if (sort == "DESC") {
            GridArray.sort((a, b) => {
                if (a[name] < b[name]) {
                    return 1 // Ascending or descending order
                }
                if (a[name] > b[name]) {
                    return -1 // Ascending or descending order
                }
                return 0;
            })
        }
        else {
            GridArray.sort((a, b) => {
                if (a[name] < b[name]) {
                    return -1; // Ascending or descending order
                }
                if (a[name] > b[name]) {
                    return 1; // Ascending or descending order
                }
                return 0;
            })
        }
        this.setState({ GridData: GridArray })
    }
    Sorting = (sort, name) => {
        this.DynamicSort(sort, name)
        //let data = []
        //let GridArray = this.state.GridData;
        //if (sort == "DESC") {
        //    switch (name) {
        //        case "BUYER_ID": {
        //            data = GridArray.sort((a, b) => (a.BUYER_ID.toString() > b.BUYER_ID.toString() ) ? 1 : -1);
        //            break;
        //        }
        //        case "RECEIVER_ID": {
        //            data = GridArray.sort((a, b) => (parseInt(a.RECEIVER_ID) > parseInt(b.RECEIVER_ID) ) ? 1 : -1)
        //            break;
        //        }
        //        case "RECV_LN_NBR": {
        //            data = GridArray.sort((a, b) => (parseInt(a.RECV_LN_NBR) > parseInt(b.RECV_LN_NBR)) ? 1 : -1)
        //            break;
        //        }
        //        case "RECEIPT_DI": {
        //            data = GridArray.sort((a, b) => (new Date(a.RECEIPT_DI) > new Date(b.RECEIPT_DI)) ? 1 : -1)
        //            break;
        //        }
        //        case "SHIPTO_ID": {
        //            data = GridArray.sort((a, b) => (a.SHIPTO_ID.toString() > b.SHIPTO_ID.toString() ) ? 1 : -1)
        //            break;
        //        } case "PO_DATE": {
        //            data = GridArray.sort((a, b) => (new Date(a.PO_DATE) > new Date(b.PO_DATE)) ? 1 : -1)
        //            break;
        //        } case "PO_ID": {
        //            data = GridArray.sort((a, b) => (a.PO_ID.toString() > b.PO_ID.toString() ) ? 1 : -1)
        //            break;
        //        } case "INV_ITEM_ID": {
        //            data = GridArray.sort((a, b) => (a.INV_ITEM_ID.toString() > b.INV_ITEM_ID.toString() ) ? 1 : -1)
        //            break;
        //        } case "BIN_LOC": {
        //            data = GridArray.sort((a, b) => (a.BIN_LOC.toString() > b.BIN_LOC.toString() ) ? 1 : -1)
        //            break;
        //        }

        //    }
        //}
        //else {
        //    switch (name) {
        //        case "BUYER_ID": {
        //            data = GridArray.sort((a, b) => (b.BUYER_ID.toString() > a.BUYER_ID.toString() ) ? 1 : -1);
        //            break;
        //        }
        //        case "RECEIVER_ID": {
        //            data = GridArray.sort((a, b) => (parseInt(b.RECEIVER_ID) > parseInt(a.RECEIVER_ID)) ? 1 : -1)
        //            break;
        //        }
        //        case "RECV_LN_NBR": {
        //            data = GridArray.sort((a, b) => (parseInt(b.RECV_LN_NBR) > parseInt(a.RECV_LN_NBR)) ? 1 : -1)
        //            break;
        //        }
        //        case "RECEIPT_DI": {
        //            data = GridArray.sort((a, b) => (new Date(b.RECEIPT_DI) > new Date(a.RECEIPT_DI)) ? 1 : -1)
        //            break;
        //        }
        //        case "SHIPTO_ID": {
        //            data = GridArray.sort((a, b) => (b.SHIPTO_ID.toString() > a.SHIPTO_ID.toString() ) ? 1 : -1)
        //            break;
        //        } case "PO_DATE": {
        //            data = GridArray.sort((a, b) => (new Date(b.PO_DATE) > new Date(a.PO_DATE)) ? 1 : -1)
        //            break;
        //        } case "PO_ID": {
        //            data = GridArray.sort((a, b) => (b.PO_ID.toString() > a.PO_ID.toString() ) ? 1 : -1)
        //            break;
        //        } case "INV_ITEM_ID": {
        //            data = GridArray.sort((a, b) => (b.INV_ITEM_ID.toString() > a.INV_ITEM_ID.toString() ) ? 1 : -1)
        //            break;
        //        } case "BIN_LOC": {
        //            data = GridArray.sort((a, b) => (b.BIN_LOC.toString() > a.BIN_LOC.toString() ) ? 1 : -1)
        //            break;
        //        }

        //    }

        //}
        ascendingOrder = !ascendingOrder;
        descendingOrder = !descendingOrder;

    }
    BindDataGrid = () => {
        return this.state.GridData.map((value, index) => {
            if (index < parseInt(this.state.PageNo) * 10 && index >= parseInt(this.state.PageNo - 1) * 10) {
                /*BUG:2473-Replace "||" in Tracking Number-Priyanka D*/
                let ISA_ASN_TRACK_NO = value.ISA_ASN_TRACK_NO
                return (
                    <React.Fragment key={index}>
                        <tr>
                            <td className="text-center">
                            </td>
                            <td className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)} >
                                <span className="accordion-arrow header-arrow" id={`arrow-${index}`} />
                            </td>
                            {/* <td className="d-sm-none d-md-table-cell"><div style={{ width: '100px' }}><a href="#" className="order-id" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target=".orderstatus-popup" onClick={e => this.PopupForLineLevelDetails(index, value, "V")} >{value.NAME1}</a></div></td>*/}
                            {/*[2/23/22], WBW - 11, PC_RR_01, Dhevanesam R*/}
                            <td className="d-none d-sm-none d-md-table-cell" >{value.BUYER_ID}</td>
                            <td className="d-none d-sm-none d-md-table-cell" >{value.RECEIVER_ID}</td>
                            <td className="d-none d-sm-none d-md-table-cell" ><div style={{ width: '80px' }}>{value.RECV_LN_NBR}</div></td>
                            <td className="d-none d-sm-none d-md-table-cell">{value.RECEIPT_DT}</td>
                            <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '80px' }}>{value.SHIPTO_ID}</div></td>
                            <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '66px' }}>{value.PO_DATE}</div></td>
                            {/*<td className="d-none d-sm-none d-md-table-cell priority-alert">{value.LINE_PRIOR}</td>*/}
                            {/* <td className="d-none d-sm-none d-md-table-cell">{value.ENTEREDEMPNAME}</td>*/}
                            <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '50px' }}><a href="#" className="order-id" data-toggle="modal" data-target="#po-details" onClick={(e) => this.PODetailPopup(value)}>{value.PO_ID}</a></div></td>
                            <td className="d-sm-none d-md-table-cell"><div style={{ width: '100px' }}>{value.INV_ITEM_ID}</div></td>
                            <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '80px' }}>{value.BIN_LOC}</div></td>




                        </tr>
                        <tr className="p d-none content-row" id={`contentrow-${index}`}>
                            <td colSpan="12">
                                <div className="accordian-body" id="order-row-1">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12">
                                            <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                                <tbody>

                                                    <h4 className="item-details-title my-3"><Trans>ItemKey</Trans><span> </span><Trans>Details</Trans></h4>
                                                    <tr className="p">
                                                        <td colSpan={12} className="hiddenRow">
                                                            <div className="accordian-body " id="order-row-1">

                                                                <div className="row mx-0 pb-0">
                                                                    <div className="col-md-12 pl-4 mb-1">

                                                                        <div className="row">
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Short Description:</label>
                                                                                <label className="item-details-value">{value.SHORT_DESCR}</label>
                                                                            </div>

                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Net Received QTY:</label>
                                                                                <label className="item-details-value">{value.QTY_SH_NETRCV}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">PO Price:</label>
                                                                                <label className="item-details-value">{value.PRICE_PO}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Ext.Price:</label>
                                                                                <label className="item-details-value">{value.EXT_PRICE}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Accepted QTY:</label>
                                                                                <label className="item-details-value">{value.QTY_LN_ACCPT}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Received Qty:</label>
                                                                                <label className="item-details-value">{value.QTY_LN_RECVD}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Rejected Qty:</label>
                                                                                <label className="item-details-value"> {value.QTY_LN_REJCT}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Returned Qty:</label>
                                                                                <label className="item-details-value"> {value.QTY_LN_RTN}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Tracking #:</label>
                                                                                {/*BUG:2473-Replace "||" in Tracking Number-Priyanka D*/}
                                                                                <label className="item-details-value ">{ISA_ASN_TRACK_NO}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Mfg ID:</label>
                                                                                <label className="item-details-value" style={{ "width": "100px", "word-break": "break-word" }}>{value.MFG_ID}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">std.Lead Time:</label>
                                                                                <label className="item-details-value">{value.LEAD_TIME}</label>
                                                                            </div>

                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Mfg Item ID:</label>
                                                                                <label className="item-details-value">{value.MFG_ITM_ID}</label>

                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Chg.Cd.:</label>
                                                                                <label className="item-details-value ">{value.ISA_CUST_CHARGE_CD}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2"><Trans>Stock Type:</Trans></label>
                                                                                <label className="item-details-value">{value.INV_STOCK_TYPE} </label>

                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Work Order#:</label>
                                                                                <label className="item-details-value">{value.ISA_WORK_ORDER_NO} </label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Machine#:</label>
                                                                                <label className="item-details-value">{value.ISA_MACHINE_NO} </label>

                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">BU In:</label>
                                                                                <label className="item-details-value">{value.BUSINESS_UNIT_IN}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">UOM:</label>
                                                                                <label className="item-details-value">{value.UNIT_MEASURE_STD}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Ship via:</label>
                                                                                <label className="item-details-value">{value.ISA_ASN_SHIP_VIA}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">OPRID:</label>
                                                                                <label className="item-details-value">{value.OPRID}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Empl. Name:</label>
                                                                                <label className="item-details-value">{value.EMPL_NAME}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">OPRNAME:</label>
                                                                                <label className="item-details-value">{value.OPRNAME}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Tariff Code:</label>
                                                                                <label className="item-details-value">{value.ISA_TARIFF_CODE}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Req. Currency:</label>
                                                                                <label className="item-details-value">{value.CURRENCY_CD}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">PO Currency:</label>
                                                                                <label className="item-details-value">{value.PO_CURRENCY}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Emp. ID:</label>
                                                                                <label className="item-details-value">{value.ISA_EMPLOYEE_ID}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Vendor ID:</label>
                                                                                <label className="item-details-value" style={{ "width": "100px", "word-break": "break-word" }}>{value.VENDOR_ID}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Vendor:</label>
                                                                                <label className="item-details-value">{value.NAME1}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Vnd Item ID:</label>
                                                                                <label className="item-details-value">{value.ITM_ID_VNDR}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">PO Qty:</label>
                                                                                <label className="item-details-value">{value.QTY_PO}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">EXT PO QTY:</label>
                                                                                <label className="item-details-value">{value.EXT_PO_QTY}</label>
                                                                            </div>

                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Ship Date:</label>
                                                                                <label className="item-details-value">{value.ISA_ASN_SHIP_DT}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Serial Id:</label>
                                                                                <label className="item-details-value">{value.SERIAL_ID}</label>
                                                                            </div>

                                                                            {/*<div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Price Curncy:</label>
                                                                                <label className="item-details-value">{value.PRICE_PO}</label>
                                                                            </div>*/}
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Dept Id:</label>
                                                                                <label className="item-details-value">{value.DEPTID}</label>
                                                                            </div>
                                                                            <div className="col-md-3 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Cust Notes:</label>
                                                                                <label className="item-details-value">{value.ISA_RECV_EXCEPT}</label>
                                                                            </div>
                                                                            <div className="col-md-8 pr-0 mb-2">
                                                                                <label className="catalog-label mr-2">Description:</label>
                                                                                <label className="item-details-value" style={{ "word-break": "break-word" }}>{value.DESCR254_MIXED}</label>
                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </React.Fragment>

                )

            }

        });
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <div className="container-fluid content-section custom-mb content-margin">
                    <div className="row">
                        <div className="col-md-12 page-heading mb-3">
                            <h5 className="page-title"><Trans>Receiving Report</Trans></h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-OrdStatus">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="row">
                                <div className="col-md-2 mb-3">
                                    <div className="rcv-res-d-flex">
                                        <label className="catalog-label mb-0 mr-2 rcv-res-lable"><Trans>Order Date</Trans></label>
                                        <select className="form-control" style={{ width: "auto" }} name="SelectedReport" value={this.state.SelectedReport} onChange={e => this.OnHandleChange(e, "SelectedReport")}>

                                            <option value="X">{t("Select ReportKey")}</option>
                                            <option value="7">{t("Last 7 Days")}</option>
                                            <option value="15">{t("Last 15 Days")}</option>
                                            <option value="30">{t("Last 30 Days")}</option>
                                            <option value="0">{t("This Month")}</option>
                                            <option value="-1">{t("Last Month")}</option>
                                            <option value="99">Search Transaction</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                {this.state.SelectedReport == "99" ? <>
                                    <div className="col-lg-4 col-md-4 col-sm-12 mb-3" id="sFT">
                                        <div className="row">
                                            <div className="col-md-6 px-2 mb-3">
                                                <label className="catalog-label"><Trans>From</Trans></label>
                                                <DatePicker className="form-control place"
                                                    id="From"
                                                    fixedHeight
                                                    placeholderText="MM/DD/YYYY"
                                                    dateFormat="MM/dd/yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    selected={this.state.FromDate}
                                                    maxDate={this.state.ToDate}
                                                    onChange={(e) => this.OnHandleChange(e, "FromDate")}
                                                //value={this.state.FromDate}
                                                />
                                                <span className="calendar-icon filter-calendar-icon" style={{ "top": "35px" }} onClick={() => $(`#From`).focus()} />

                                            </div>
                                            <div className="col-md-6 px-2">
                                                <label className="catalog-label">To <span className="info-container"><img className="info-searchpage" src="Images/info-icon.png" /><span className="info-content info-position"><Trans>date range is limited to 3 months</Trans></span></span></label>
                                                <DatePicker className="form-control place "
                                                    id="To"
                                                    fixedHeight
                                                    placeholderText="MM/DD/YYYY"
                                                    dateFormat="MM/dd/yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    selected={this.state.ToDate}
                                                    minDate={this.state.FromDate}
                                                    onChange={(e) => this.OnHandleChange(e, "ToDate")}
                                                //value={this.state.ToDate}
                                                />
                                                <span className="calendar-icon filter-calendar-icon" style={{ "top": "35px" }} onClick={() => $(`#To`).focus()} />

                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-md-8 col-sm-12 mb-3" id="sdrp">
                                        <div className="input-group dropdown-search mb-2 w-100 mt-4">
                                            <div className="input-group-prepend">
                                                <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >{this.state.SearchBy}</button>
                                                <div className="dropdown-menu" style={{}}>
                                                    <a className="dropdown-item" href="#" onClick={(e) => this.OnHandleChange(e, "SearchBy", "PO Number")}><Trans>PO Number</Trans></a>
                                                    <a className="dropdown-item" href="#" onClick={(e) => this.OnHandleChange(e, "SearchBy", "MFG Item ID")}><Trans>MFG Item ID</Trans></a>
                                                    <a className="dropdown-item" href="#" onClick={(e) => this.OnHandleChange(e, "SearchBy", "Vendor Item ID")}><Trans>Vendor Item ID</Trans></a>
                                                    <a className="dropdown-item" href="#" onClick={(e) => this.OnHandleChange(e, "SearchBy", "Item Description")}><Trans>Item Description</Trans></a>
                                                    <a className="dropdown-item" href="#" onClick={(e) => this.OnHandleChange(e, "SearchBy", "Tracking Number")}><Trans>Tracking Number</Trans></a>
                                                    <a className="dropdown-item" href="#" onClick={(e) => this.OnHandleChange(e, "SearchBy", "Item Number")}><Trans>Item Number</Trans></a>
                                                </div>
                                            </div>

                                            <input type="text" className="form-control " placeholder="Search" aria-label="Text input with dropdown button" value={this.state.SearchCriteria} onChange={e => this.OnHandleChange(e, "SearchCriteria")} id="SearchCriteria" />
                                            {this.state.SearchCriteria ? <span className="search-cancel-header cursor-pointer" style={{ "right": "6px" }} onClick={() => this.ClearSearch()}></span> : null}


                                        </div>
                                        <div className="W-100 mt-3">
                                            <div className="custom-control custom-checkbox mt-0 item-custom-control ml-0 float-left">
                                                <input type="checkbox" className="custom-control-input" id="FirstPOOnly" name="FirstPOOnly" checked={this.state.UseDateRangeCheckbox} onChange={e => this.OnHandleChange(e, "UseDateRangeCheckbox")} />
                                                <label className="custom-control-label" htmlFor="FirstPOOnly" />
                                            </div>
                                            <label className="catalog-label float-left mt-1 space-check " htmlFor="FirstPOOnly"><Trans>Use date range entered above to limit search</Trans></label>
                                        </div>
                                    </div>


                                </> : null}
                            </div>
                            <div className="row">
                                <div className="col-md-12 text-right my-3">
                                    <button className="btn btn-primary custom-btn-primary primary-btn" onClick={this.SearchCriteriaCheck}><Trans>Apply</Trans><span> </span> <Trans>Filter</Trans></button>
                                    {/* <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-3" ><Trans>Save</Trans><span> </span> <Trans>Preference</Trans></button>*/}
                                </div>
                            </div>
                            {/*[2/23/22], WBW - 11, PC_RR_01, Dhevanesam R*/}
                            <div className="row">
                                <div className="col-md-12 text-right mb-3">
                                    {IsPageLoad == false && this.state.totalCount > 0 ? <>
                                        {/*<button className="btn btn-primary custom-btn-primary primary-btn float-left mr-3" onClick={this.addFavItemsToCart}><Trans>Buy Checked Items</Trans></button>*/}
                                        {/*<button className="btn btn-primary custom-btn-primary primary-btn float-left mr-3" onClick={this.expandAll}><Trans>{!this.state.isExpand ? `Expand All` : `Collapse All`}</Trans></button>*/}
                                        <button className="btn btn-primary custom-btn-primary primary-btn" onClick={e => this.export()}><Trans>Export to Excel</Trans></button></> : null}
                                </div>
                                <div className="col-md-12">
                                    <div className="table-responsive">
                                        {IsPageLoad == false ? <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                            {this.state.totalCount > 0 ? <thead>
                                                <tr>
                                                    <th />
                                                    <th />
                                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Buyer ID</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "BUYER_ID")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "BUYER_ID")}><img src="Images/sort1.svg" /></span></th>
                                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Recv ID</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "RECEIVER_ID")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "RECEIVER_ID")}><img src="Images/sort1.svg" /></span></th>
                                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Recv Line #</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "RECV_LN_NBR")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "RECV_LN_NBR")} ><img src="Images/sort1.svg" /></span></th>
                                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Receipt</Trans><span> </span> <Trans>Date</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "RECEIPT_DT")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "RECEIPT_DT")}><img src="Images/sort1.svg" /></span></th>
                                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Ship To</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "SHIPTO_ID")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "SHIPTO_ID")}><img src="Images/sort1.svg" /></span></th>
                                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>PO DT</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "PO_DATE")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "PO_DATE")}><img src="Images/sort1.svg" /></span></th>
                                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>PO #</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "PO_ID")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "PO_ID")}><img src="Images/sort1.svg" /></span></th>
                                                    <th className="d-md-table-cell position-sort-icon"><Trans>Item ID</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "INV_ITEM_ID")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "INV_ITEM_ID")}><img src="Images/sort1.svg" /></span></th>
                                                    <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Bin Location</Trans><span className="sort-up ml-1" onClick={(e) => this.Sorting("ASC", "BIN_LOC")}><img src="Images/sort2.svg" /></span><span className="sort-down ml-1" onClick={(e) => this.Sorting("DESC", "BIN_LOC")}><img src="Images/sort1.svg" /></span></th>

                                                </tr>
                                            </thead> : (

                                                    <tr>
                                                        <td colSpan={11}>
                                                            <section className="site-undercontruction container text-center center-panel pt-4">
                                                                <div className="img-section">
                                                                    <img src="images/nosearch.jpg" alt="imagefile" />
                                                                </div>
                                                                <p className="search-result-content pt-4"><Trans>Sorry, we couldn’t find any search result</Trans>
                                                                </p>
                                                            </section>
                                                        </td>
                                                    </tr>)}
                                            <tbody>
                                                {this.state.totalCount > 0 ? this.BindDataGrid() : null}
                                            </tbody>
                                        </table> : null}
                                        {IsPageLoad == false && this.state.GridData.length > 0 ?
                                            <div className="col-md-12 ">
                                                <span className="total-records mt-2 d-inline-block">
                                                    <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.GridData.length}</span>
                                                </span>
                                                {this.state.GridData.length > 10 ? <ReactPaginate
                                                    previousLabel={<span className="right-pagination-arrow" />}
                                                    nextLabel={<span className="left-pagination-arrow" />}
                                                    previousClassName={'page-item'}
                                                    nextClassName={'page-item'}
                                                    previousLinkClassName={'page-link'}
                                                    nextLinkClassName={'page-link'}
                                                    disabledClassName={'disabled'}
                                                    breakLabel={'...'}
                                                    breakClassName={'page-item'}
                                                    breakLinkClassName={'page-link'}
                                                    pageCount={this.state.PageCount}
                                                    marginPagesDisplayed={1}
                                                    pageRangeDisplayed={2}
                                                    onPageChange={e => this.handlePageClick(e)}
                                                    containerClassName={'custom-pagination pagination float-right'}
                                                    pageClassName={'page-item'}
                                                    pageLinkClassName={'page-link'}
                                                    activeClassName={'active'}
                                                    hrefBuilder={() => '#'}
                                                    forcePage={this.state.PageNo - 1}
                                                /> : null}

                                            </div> : null}
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>
                </div>
                <div className="modal" id="StoreLocation-id">
                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Order</Trans><span> </span> <Trans>Approval</Trans><span> </span><Trans> History</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
                               </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12 mb-5">
                                        <span className="float-left cc-help-info"><Trans>Order</Trans><span> </span> <Trans>Details</Trans></span>
                                        <span className="float-right cc-help-info">{CookieService.getLocalStorageValues("Session_CONAME")} </span>
                                    </div>
                                    <div className="row" style={{ flexWrap: 'nowrap', width: '70%' }}>
                                        <div className="col-md-12 edit-desc-field mb-4 " style={{ marginLeft: '5%', marginRight: '0%' }}>
                                            <div className="row mb-3">
                                                <label className="col-md-5 quick-label"><Trans>Business</Trans> <span> </span><Trans>Unit</Trans> <span> :</span> </label>
                                                <label className="col-md-7 quick-value">{}</label>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-md-5 quick-label"><Trans></Trans></label>
                                                <label className="col-md-7 quick-value">{}</label>
                                            </div>

                                        </div>

                                    </div>

                                    <div className="col-lg-12 float-left ">
                                        <div className="table-responsive">
                                            <table className="table ZEUS_Grid FOM-grid">
                                                <thead>
                                                    <tr>
                                                        <th><Trans>Owner</Trans></th>
                                                        <th><Trans>Crib</Trans></th>
                                                        <th><Trans>Aisle</Trans></th>
                                                        <th><Trans>Row</Trans></th>
                                                        <th><Trans>Shelf</Trans></th>
                                                        <th><Trans>Bin</Trans></th>
                                                        <th><Trans>Qty</Trans></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.BindStoreLocation()}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-4" data-dismiss="modal"><Trans>Close</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*[2/23/22], WBW - 11, PC_RR_04, Dhevanesam R*/}
                <div className="modal" id="po-details" data-backdrop="static" data-keyboard="false" >
                    <div className="modal-dialog modal-xl custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><span>PO </span><Trans>Details</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                {/*<div className="col-md-12 p-0">
                                    <span className="float-right cc-help-info ">{CookieService.getLocalStorageValues("Session_CONAME")} </span>
                                </div>*/}
                                <div className="col-md-12 p-0 float-left my-3">
                                    <div className="row mb-3">
                                        <h5 className="col-md-12 info-label "><span>PO </span><Trans>Details</Trans></h5>
                                    </div>
                                    {this.state.VenderDetail[0] != undefined || this.state.VenderDetail.length > 0 ?

                                        this.POData() : null}

                                    {this.state.VenderDetail[0] != undefined || this.state.VenderDetail.length > 0 ?


                                        this.PODetailhd() : null}
                                </div>
                                <div className="col-md-12 float-left mb-3 p-0">
                                    <label className="info-label pl-1 "><Trans>PO Header Status:</Trans></label>
                                    {this.PoHdStatus()}

                                </div>
                                {/*[12/2/22, Bug - 2958 - To display expand and collapse all button text & functionality in a single button, Dhevanesam R]*/}
                                <div className="col-md-12 mb-2 float-left p-0">
                                    <button className="btn btn-primary custom-btn-primary primary-btn float-left mr-3" onClick={this.POExpandAll}>{!this.state.isPOExpand ? `Expand All` : `Collapse All`}</button>
                                    {/*<button className="btn btn-secondary custom-btn-secondary secondary-btn float-left px-4 mr-3" onClick={this.POCollapseAll} ><Trans>Collapse All</Trans></button>*/}
                                </div>
                                <div className="col-lg-12 float-left p-0">
                                    <div className="table-responsive">
                                        <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                            <thead>
                                                <tr>
                                                    <th />
                                                    <th>Req Ln #</th>
                                                    <th>Ln #</th>
                                                    <th className="d-none d-sm-none d-md-table-cell">Sch #</th>
                                                    <th><Trans>Line</Trans><span> </span><Trans>Status</Trans></th>
                                                    <th className="d-none d-sm-none d-md-table-cell "><span>Orig. </span><Trans>Due</Trans><span> </span><Trans>Date</Trans></th>
                                                    <th className="d-none d-sm-none d-md-table-cell "><Trans>Expected</Trans><span> </span><Trans>Delivery</Trans><span> </span><Trans>Date</Trans></th>
                                                    <th className="d-none d-sm-none d-md-table-cell "><Trans>Request by</Trans><span> </span><Trans>Date</Trans></th>
                                                    <th className="d-none d-sm-none d-md-table-cell ">PO QTY</th>
                                                    <th className="d-none d-sm-none d-md-table-cell "><Trans>Received</Trans><span> QTY</span></th>
                                                    <th className="d-none d-sm-none d-md-table-cell "><Trans>Reject</Trans><span> QTY</span></th>
                                                    {this.state.showprice != "0" && this.state.blockprice == "N" ? <th className="text-right"><Trans>Purchase</Trans><span> </span><Trans>Price</Trans></th> : null}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.bindPODataGrid()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-md-12 text-center float-left mb-2">
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4" data-dismiss="modal"><Trans>Close</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }

}
export default withTranslation()(RcvRptComponent);